import axios from "axios";

export interface SessionRecord {
  id: string;
  studentId: string;
  academicSessionId: string;
  classId: string;
  sectionId: string;
  formNumber?: string;
  dateOfAdmission?: string;
  schoolId: string;
  createdAt: string;
  updatedAt: string;
  student?: any;
  academicSession?: any;
  class?: any;
  section?: any;
}

export interface SessionRecordRowInput {
  id?: string;
  academicSessionId: string;
  classId: string;
  sectionId: string;
  formNumber?: string;
  dateOfAdmission?: string;
}

export const sessionRecordApi = {
  historyByStudent: async (studentId: string): Promise<SessionRecord[]> => {
    const response = await axios.get(
      `/scholar-register/session-record/student/${studentId}`,
    );
    return response.data;
  },

  replaceForStudent: async (
    studentId: string,
    records: SessionRecordRowInput[],
  ): Promise<SessionRecord[]> => {
    const response = await axios.post(
      `/scholar-register/session-record/student/${studentId}`,
      { records },
    );
    return response.data;
  },
};
